import MasterTab from 'src/components/Layouts/MasterTab.vue';
import HarvestQuality from "src/views/Pages/Dashboard/Grow/Reports/HarvestQuality/HarvestQuality.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const HarvestQualityRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'harvestquality',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.harvest_quality',
          component: HarvestQuality,
          meta: {
            prefix_permission: 'grow_harvestquality',
          },
        },
      ],
    },
  ],
};

export default HarvestQualityRoutes;